import styled from 'styled-components';

export const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 250px;
  height: 150px;
  z-index: 1;
`;

export const ModalContent = styled.div`
  border-radius: 24px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
  position: absolute;
  width: 350px;
  height: 200px;
  overflow: hidden;
  background-color: white;
`;

export const CancelButton = styled.div`
  background-color: white;
  color: #4a4f7f;
  width: 125px;
  height: 27px;
  border: 1px solid #4a4f7f;
  border-radius: 25px;
  margin: 0 7px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: karla;
`;

export const ModalButtonsContainer = styled.div`
  display: flex;
  margin-top: 25px;
  margin-right: 15px;
  padding: 25px 0;
`;

export const ModalInnerContent = styled.div`
  font-size: 24px;
  height: 50px;
  width: 100%;
  background-color: #028a8a;
  padding-top: 10px;
  padding-left: 95px;
`;

export const ModalTextContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  margin-top: 10px;
`;

export const DataColumn = styled.div`
  display: flex;
`;

export const SectionHeader = styled.div`
  font-family: Lato;
  color: #0f0f0f;
  font-size: 14px;
`;

export const SelectStyle = styled.select`
  width: 225px;
  height: 32px;
  border: 2px solid #e9e7e7;
  margin-top: -5px;
`;

export const SubmitButton = styled.input`
  background-color: #4a4f7f;
  color: white;
  width: 125px;
  height: 27px;
  border: 1px solid #4a4f7f;
  border-radius: 25px;
  margin: 0 7px;
  cursor: pointer;
  font-family: karla;
`;

export const SpinnerButton = styled.div`
  background-color: #4a4f7f;
  color: white;
  width: 125px;
  height: 30px;
  border: 1px solid #4a4f7f;
  border-radius: 25px;
  font-family: Karla, sans-serif;
  outline: none;
`;
